import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2e4fe9e2")
const _hoisted_1 = { class: "p-[12px]" }
const _hoisted_2 = { class: "header px-[8px]" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Connect a wallet", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_X = _resolveComponent("X")!
  const _component_WalletButton = _resolveComponent("WalletButton")!
  const _component_BalModal = _resolveComponent("BalModal")!

  return (_openBlock(), _createBlock(_component_BalModal, {
    show: _ctx.isVisible,
    noPad: "",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_X, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wallets, (wallet) => {
          return (_openBlock(), _createBlock(_component_WalletButton, {
            key: wallet,
            wallet: wallet
          }, null, 8, ["wallet"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}